import { render, staticRenderFns } from "./new-league-modal.vue?vue&type=template&id=59a7c356&"
import script from "./new-league-modal.vue?vue&type=script&lang=js&"
export * from "./new-league-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports